export default __webpack_public_path__ + "ui/assets/img/add-2.svg";